import { OPERATOR_GROUP_SERVICE_NAME, OperatorGroupServiceProvider } from './operator-group.service'
import { OPERATOR_GROUP_OPERATORS_SERVICE_NAME, OperatorGroupOperatorsServiceProvider } from './operator-group.operators.service'
import { OPERATOR_GROUP_TECHNICAL_PERMISSIONS_SERVICE_NAME, OperatorGroupTechnicalPermissionsServiceProvider } from './operator-group.technical-permissions.service'

export const OPERATOR_GROUP_SERVICES_MODULE_NAME = 'simax.services.operator-group'

const module = angular.module(OPERATOR_GROUP_SERVICES_MODULE_NAME, [])

module.provider(OPERATOR_GROUP_SERVICE_NAME, OperatorGroupServiceProvider)
module.provider(OPERATOR_GROUP_OPERATORS_SERVICE_NAME, OperatorGroupOperatorsServiceProvider)
module.provider(OPERATOR_GROUP_TECHNICAL_PERMISSIONS_SERVICE_NAME, OperatorGroupTechnicalPermissionsServiceProvider)
